import { ArrowRight, RadioIcon } from "lucide-react";
import Image from "next/image";
import Link from "next/link";

type KnowledgeHubCardType = "video" | "article" | "file";
type KnowledgeHubCardProps = {
	thumbnail?: string;
	title?: string;
	description?: string;
	type?: KnowledgeHubCardType;
	isLive?: boolean;
	link: string;
};

const CTA: {
	[key in KnowledgeHubCardType]: string;
} = {
	video: "Watch video",
	article: "Read article",
	file: "Show more",
};

// TODO: Make props required
function KnowledgeHubCard({
	thumbnail = "/images/listing-page/knowledgeHubCard-pic-1.svg",
	title = "Proptechbuzz Webinar is on",
	description = "Make your product/reports in the eyes of the global audience",
	type = "video",
	link,
	isLive,
}: KnowledgeHubCardProps) {
	// TODO: Show icon on thumbnail depending on the type
	console.log(type);

	return (
		<div className="relative mb-5 flex flex-wrap items-center justify-between rounded bg-[url('/images/listing-page/knowledgeHubCard-background.jpg')] bg-cover bg-no-repeat px-4 py-3 md:flex-nowrap">
			{isLive && (
				<div className="absolute right-2 top-2 flex items-center gap-1 rounded bg-red-600 px-1 text-white">
					<span>Live</span>
					<RadioIcon className="h-5 w-5" />
				</div>
			)}

			<div className="flex flex-wrap items-center gap-4 md:flex-nowrap">
				<div className="self-stretch md:basis-1/3">
					<Image
						src={thumbnail}
						alt={title}
						className="h-full w-full rounded object-cover"
						width={1080}
						height={1080}
					/>
				</div>

				<div className="flex flex-col flex-wrap items-start justify-between gap-2 md:basis-2/3 md:flex-wrap">
					<h4 className="font-semibold tracking-tight md:text-lg">{title}</h4>
					<p title={description} className="line-clamp-3 text-sm text-gray-600">
						{description}
					</p>

					<Link
						href={link || "#"}
						target="_blank"
						className="flex items-center gap-2 font-semibold text-brand-primary"
					>
						<span>{CTA[type]}</span>
						<span>
							<ArrowRight className="h-4 w-4" />
						</span>
					</Link>
				</div>
			</div>
		</div>
	);
}

export default KnowledgeHubCard;
